import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

interface GateEntrySummary {
  totalEntries: number;
  inwardShipments: number;
  outwardShipments: number;
  todaysEntries: number;
}

interface GateEntrySummaryResponse {
  success: boolean;
  message: string;
  data: GateEntrySummary;
}

export const useGateEntrySummary = () => {
  return useQuery({
    queryKey: ['gateEntrySummary'],
    queryFn: async (): Promise<GateEntrySummaryResponse> => {
      const response = await api.get<GateEntrySummaryResponse>('/gate-entries/summary/stats');
      return response as any;
    },
    refetchInterval: 30000, // Auto-refresh every 30 seconds
    staleTime: 10000, // Consider data stale after 10 seconds
  });
};
